'use strict';

$('.button-capillary-schedule').on('click', function () {
  var index = $(this).index();
  $('.tables-capillary-schedule').addClass('is-hide').eq(index).removeClass('is-hide');
});
